import Icon from "@/assets/satellite.svg"

/**
 * Logo component displays the logo for SpaceLinq for Web.
 * Includes a satellite icon and the name of the application.
 */
const Logo = () => (
    <div className="flex flex-row items-center gap-2">
      <img src={Icon} alt="Satellite Icon" className="w-8 h-8" />
      <div>
        <h1 className="dialog-title">spacelinqforweb</h1>
      </div>
    </div>
  );
  
  export default Logo;
